import { OnboardingSurveyNew } from 'features/onboardingJourney/new-onboarding-2025/onboarding-survey-new';

export function OnboardingSurvey() {
  return <OnboardingSurveyNew />;
}
